import React from "react";
import {
  CellStack,
  PrimaryText,
  SecondaryText,
} from "./KgInspectorTwoLineCell.styles";
import type { KgInspectorTwoLineCellProps } from "./KgInspectorTwoLineCell.types";

/**
 * Two stacked text lines inside an inspector data-grid cell (Figma 2745-38725).
 * Shared across drawer relationship tabs — table name / column, join type / cardinality.
 */
export const KgInspectorTwoLineCell: React.FC<KgInspectorTwoLineCellProps> = ({
  primary,
  secondary,
}) => (
  <CellStack>
    <PrimaryText title={primary}>{primary}</PrimaryText>
    {secondary && <SecondaryText title={secondary}>{secondary}</SecondaryText>}
  </CellStack>
);

export default KgInspectorTwoLineCell;
